<script setup lang="ts">
  const props = defineProps<{
    coverageItems: any
    isEmptyState: boolean
  }>()

  const { quotingConfig } = QuotingConfig.use()
</script>

<template>
  <div
    :class="[
      'grid place-items-center gap-y-4 divide-x divide-border md:divide-y-0 lg:px-16',
      { 'grid-cols-2 md:grid-cols-4': coverageItems.length > 3 },
      {
        'grid-cols-1 xs:grid-cols-3 md:grid-cols-3':
          coverageItems.length < 4 && !quotingConfig.smartCardShowBenchmarks
      },
      {
        'grid-cols-1 sm:grid-cols-3 md:grid-cols-3':
          coverageItems.length < 4 && quotingConfig.smartCardShowBenchmarks
      }
    ]"
  >
    <div
      v-for="coverageItem in coverageItems"
      :key="coverageItem.id"
      :class="[
        'flex w-full flex-col items-center justify-center gap-y-2',
        { 'cursor-pointer': !coverageItem.emptyAction?.condition && coverageItem.onClick }
      ]"
      @click="coverageItem.onClick"
    >
      <div class="text-xs font-semibold uppercase text-gray-700">{{ coverageItem.label }}</div>
      <div class="flex h-[42px] items-center justify-center">
        <HpAnchor
          v-if="
            coverageItem.emptyAction &&
            coverageItem.emptyAction.condition &&
            !quotingConfig.smartCardShowBenchmarks
          "
          @click.prevent="coverageItem.emptyAction.do"
          class="font-semibold no-underline"
        >
          {{ coverageItem.emptyAction.text }}
        </HpAnchor>
        <component
          v-else-if="coverageItem.emptyState && coverageItem.emptyAction.condition"
          :is="coverageItem.emptyState"
        ></component>
        <component
          v-else-if="!_isNil(coverageItem.component)"
          :is="coverageItem.component"
          :benchmark="coverageItem.benchmark"
        ></component>
        <div v-else class="text-[30px] font-bold leading-tight">{{ coverageItem.value }}</div>
      </div>
      <HpAnchor
        v-if="
          coverageItem.emptyAction &&
          coverageItem.emptyAction.condition &&
          quotingConfig.smartCardShowBenchmarks
        "
        @click.prevent="coverageItem.emptyAction.do"
        class="font-semibold no-underline"
      >
        {{ coverageItem.emptyAction.text }}
      </HpAnchor>
      <QuoteBenchmark
        v-else-if="quotingConfig.smartCardShowBenchmarks"
        :id="coverageItem.id"
        :benchmark="coverageItem.benchmark"
      />
    </div>
  </div>
</template>

<style scoped></style>
